const intStrRegex = /^-?\d/

const floatStrRegex = /^-?\.?\d/

export const safeParseInt = (s: string | undefined): number | undefined => (!!s && intStrRegex.test(s) ? parseInt(s) : undefined)

export const safeParseFloat = (s: string | undefined): number | undefined => (!!s && floatStrRegex.test(s) ? parseFloat(s) : undefined)
